import { cn } from "@newxsystems/shared";
import { VelvetAction } from "../VelvetAction/VelvetAction";
import { VelvetMedia } from "../VelvetMedia/VelvetMedia";
import { VelvetRichText } from "../VelvetRichText/VelvetRichText";
import type { IHeroBackgroundImageProps } from "./HeroBackgroundImage.props";

export const HeroBackgroundImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
}: IHeroBackgroundImageProps) => {
  const centered = alignment === "center";
  return (
    <div className="relative flex min-h-[44rem] overflow-hidden bg-ink md:min-h-[54rem]">
      <VelvetMedia
        className="absolute inset-0 h-full"
        imageClassName="object-cover saturate-[0.7] contrast-110"
        media={image.image}
        priority
        sizes="(min-width: 1536px) 1440px, calc(100vw - 48px)"
      />
      <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(11,8,12,0.92)_0%,rgba(11,8,12,0.52)_48%,rgba(11,8,12,0.12)_100%)]" />
      <div aria-hidden="true" className="absolute bottom-0 left-[12%] top-0 w-px bg-thread" />
      <div className="relative z-10 mx-auto flex w-full max-w-[100rem] items-end px-5 py-16 md:px-10 md:py-24 lg:px-16">
        <div
          className={cn(
            "w-full max-w-[70rem] border-t border-parchment/60 pt-6 text-parchment",
            centered && "mx-auto text-center",
          )}
        >
          <div className={cn("flex flex-col gap-5", centered && "items-center")}>
            {eyebrow ? (
              <p className="font-velvet-body text-base italic text-thread">{eyebrow}</p>
            ) : null}
            {heading ? (
              <h1 className="max-w-[13ch] font-velvet-display text-6xl font-black uppercase leading-[0.78] tracking-[-0.04em] [overflow-wrap:anywhere] md:text-8xl lg:text-[6rem]">
                {heading}
              </h1>
            ) : null}
            {description ? (
              <VelvetRichText className="max-w-[60ch] text-bone" content={description} />
            ) : null}
            {buttons?.length ? (
              <div className={cn("flex flex-wrap gap-3 pt-2", centered && "justify-center")}>
                {buttons.map((button, index) => (
                  <VelvetAction
                    action={button}
                    className="border-bone"
                    key={`${button.href}-${index}`}
                  />
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

HeroBackgroundImage.displayName = "Content::HeroBackgroundImage";
